import { put, call, take, fork } from 'redux-saga/effects'
import { AICreatorGenerateCourseService } from '../../api/ai-creator'
import { aICreatorGenerateCourseSuccess } from '../../reducers/ai-creator/action'
import { GENERATE_COURSE } from '../../reducers/ai-creator/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* generateCourseFlow(payload) {
  try {
    const { req, callback } = payload

    const response = yield call(AICreatorGenerateCourseService, req)

    yield put(aICreatorGenerateCourseSuccess(response == '' ? req : response))
    yield put(operationSuccess())
    callback(response)
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* aICreatorGenerateCourseWatcher() {
  while (true) {
    const action = yield take(GENERATE_COURSE)
    const { payload } = action

    yield fork(generalSaga, generateCourseFlow, payload, false)
  }
}
